module.exports = __webpack_public_path__ + "static/media/pin.db523b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerChooser/pin.svg
// module id = 904
// module chunks = 0